import { getApiInst } from '~/atoms/MangoApi'

import { createMessagingApi } from '@mangovoice/messaging-ui'

export const messagingGroupsApi = createMessagingApi(
  getApiInst().getHttpTransport(),
)
